import { useCallback, useState } from "react";
import { getApiErrorMessage } from "../../../lib/result-codes";
import { deactivateUser as deactivateUserApi } from "../api/users.api";

export interface UseDeactivateUserReturn {
  deactivateUser: (id: string) => Promise<void>;
  loading: boolean;
  error: string | null;
}

export function useDeactivateUser(): UseDeactivateUserReturn {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const deactivate = useCallback(async (id: string) => {
    setLoading(true);
    setError(null);
    try {
      await deactivateUserApi(id);
    } catch (requestError: unknown) {
      setError(getApiErrorMessage(requestError, "Failed to deactivate user"));
      throw requestError;
    } finally {
      setLoading(false);
    }
  }, []);
  return { deactivateUser: deactivate, loading, error };
}
